var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"min-height":"100%","min-width":"80%"}},[_c('v-card-title',[_vm._v(" NMIの上限・下限 ")]),_c('v-card-text',{staticClass:"chart-container"},[_c('Chart',{attrs:{"chartData":_vm.chartData,"options":_vm.options}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }